import { TermsCheckoutPart } from "@/checkout/Sections/TermsSection/types";

export const DEFAULT_TERMS_VALUES: TermsCheckoutPart = {
  termsAgreement: false,
  newsletterConsent: false,
};
